export default "/images/c50b265b79ec34dc436ece57ef6023be.png";